import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=5a4aff02&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=5a4aff02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4aff02",
  null
  
)

export default component.exports